import { useHistory } from 'react-router-dom';
import { Card } from 'reactstrap';

import { PathsLayouts } from '../../../../config/routes';
import {
  NonStructuredFormDataLoaderProvider,
  useNonStructuredFormDataLoader,
} from '../../loaders/NonStructuredLoader';
import { NonStructuredSectionsFiltersFormLoader } from '../hooks/NonStructuredSectionsFiltersFormLoader';
import { NonStructuredSectionForm } from './NonStructuredSectionForm';

const SectionsCreateContent = () => {
  const history = useHistory();
  const {
    result: formDataResult,
    loading,
    refresh,
  } = useNonStructuredFormDataLoader();

  const handleBack = () => {
    history.push(`${PathsLayouts.nonStructured}/sections`);
  };
  const handleCreated = (id: number) => {
    history.push(`${PathsLayouts.nonStructured}/sections/${id}`);
  };

  return (
    <Card className="p-4 mt-2 mx-3">
      <NonStructuredSectionForm
        onCancel={handleBack}
        onSuccess={handleCreated}
        formData={formDataResult?.success ? formDataResult.data : undefined}
        loading={loading}
        error={formDataResult?.success ? undefined : formDataResult?.data}
        retry={refresh}
      />
    </Card>
  );
};

const SectionsCreate = () => {
  return (
    <NonStructuredFormDataLoaderProvider fetchImmediately>
      <NonStructuredSectionsFiltersFormLoader fetchImmediately>
        <SectionsCreateContent />
      </NonStructuredSectionsFiltersFormLoader>
    </NonStructuredFormDataLoaderProvider>
  );
};

export default SectionsCreate;
